import React from "react";
import { Box } from "@mui/material";
import FormType from "../../../../shared/components/FormType";
import { FieldConfigs } from "../../../../shared/components/FormType";
import { api } from "../../../../shared/hooks/api";
import { Provider } from "../../../../data/entities";

interface ImportMaterialFormProps {
    formData: any;
    onChange: (data: any) => void;
}

export const ImportMaterialForm = ({ formData, onChange }: ImportMaterialFormProps) => {
    const [{ data }] = api.get('/materials/providers/', { page: 1, page_size: Number.MAX_SAFE_INTEGER });

    const handleProviderSelect = (provider: Provider) => {
        onChange({
            ...formData,
            provider_name: provider?.name || "",
        });
    };

    const fields: FieldConfigs[] = [
        {
            label: "Nhà cung cấp",
            type: "autocomplete",
            key: "provider_name",
            required: true,
            options: data?.results?.map((provider: Provider) => ({
                ...provider,
                text: provider.name,
                value: provider.name,
            })),
            onChange: handleProviderSelect,
            noDataText: "Không tìm thấy nhà cung cấp",
        },
        {
            label: "Người giao hàng",
            type: "text",
            key: "deliverer",
            required: false,
        },
        {
            label: "Ngày nhập",
            type: "calendar",
            key: "import_date",
            required: true,
        },
        {
            label: "Phương thức nhập",
            type: "dropdown",
            key: "input_method",
            required: true,
            options: [
                { text: "Mua hàng trong nước", value: "Mua hàng trong nước" },
                { text: "Mua hàng nhập khẩu", value: "Mua hàng nhập khẩu" },
                { text: "Khác", value: "Khác" },
            ],
        },
        {
            label: "Ghi chú",
            type: "text",
            key: "note",
            required: false,
        },
    ];

    return (
        <Box sx={{ width: "100%" }}>
            <FormType
                title="Thông tin nhập kho"
                fields={fields}
                validated={false}
                requireData={formData}
                mergeFormData={onChange}
            />
        </Box>
    );
};
